import { createContext } from 'react';

interface AppContextType {
  isRunning: boolean;
  setIsRunning: (value: boolean) => void;
  showStats: boolean;
  setShowStats: (value: boolean) => void;
}

export const AppContext = createContext<AppContextType>({
  isRunning: false,
  setIsRunning: () => {},
  showStats: false,
  setShowStats: () => {},
});